import { Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BulkEditChangeRecord} from '../../../../model/bulk-edit-change-record';
import {Locale} from '../../../../model/locale';
import {Product} from '../../../../model/product';
import {TemplatesService} from '../../../../services/templates.service';
import { checkBreakTag } from '@/app/components/common/common';
import { ToastrService } from 'ngx-toastr';
import { DiffTableFormat, DiffTableFormatOption } from '@/app/text-diff/ngx-text-diff.model';


@Component({
  selector: 'app-bulk-edit-change-diff',
  templateUrl: './bulk-edit-change-diff.component.html',
  styleUrls: ['./bulk-edit-change-diff.component.scss']
})
export class BulkEditChangeDiffComponent implements OnInit {
  @Input() locales: Locale[];
  @Input() localeSel: Locale;
  @Input() products: Product[];
  @Input() productSel: Product;
  @Input() showToolbar = true;
  @Input() showBtnToolbar = true;
  @Input() record: BulkEditChangeRecord;
  @Input() index: number;

  @Output() checkBreakTagCondition: EventEmitter<any> = new EventEmitter<any>();

  public  saveBreakTag = true;
  public setSaveButton = [];


  @Input() format: DiffTableFormat = 'SideBySide';
  public formatOptions: DiffTableFormatOption[] = [
    {
      id: 'side-by-side',
      name: 'side-by-side',
      label: 'Side by Side',
      value: 'SideBySide',
      icon: 'la-code',
    },
    {
      id: 'line-by-line',
      name: 'line-by-line',
      label: 'Line by Line',
      value: 'LineByLine',
      icon: 'la-file-text',
    },
  ];

  constructor(
    private toastr: ToastrService,
  ) {}

  ngOnInit() {
    if (
      this.record.deliveryPath !== "EMAIL" &&
      this.record.deliveryPath !== "SMS"
    ) {
      const brekTag = checkBreakTag(
        [...this.record.newContent.content.matchAll(/(?=strength)(.*?)(?=>)|(?=time)(.*?)(?=>)/g)],
        this.saveBreakTag,
        this.toastr
      );
      if (brekTag.every((breakTag: any) => breakTag.checkBreakTag)) {
        brekTag.forEach(
          (breakTag: any) =>
            (this.record.newContent.content =
              this.record.newContent.content.replaceAll(
                breakTag.text,
                breakTag.text.replace(/'/g, '"')
              ))
        );
        this.checkBreakTagCondition.emit(false);
      } else {
        this.checkBreakTagCondition.emit(true);
      }
    }
  }

  public setDiffTableFormat(format: DiffTableFormat) {
    this.format = format;
  }

  public transformHTMLText(htmlText: string) {
    return htmlText.replace(/(?:\r\n|\r|\n)/g, '<br/>').replace(/(<br\s*[\/]?>)/ig, '¶$1');
  }

  public getLocaleTooltip(localeName: string) {
    const found = this.locales.find(locale => locale.localeName === localeName);
    return found && found.displayLabels && found.displayLabels.en_US ? found.displayLabels.en_US : localeName;
  }

  public getOperatorProgramProductTooltip(productId: string) {
    const found = this.products.find(product => product.id === productId);

    return TemplatesService.getOperatorProgramProductDisplayLabel(found);
  }

  public getProductDisplayLabel(productId: string) {
    return this.products.find(product => product.id === productId).displayLabel;
  }

}
